import { AnimatePresence, motion } from "motion/react";

import { memo, useState } from "react";

import { IconVolume, IconVolumeOff } from "@/components/icons/player.icons";

const MuteButton = memo(
  ({
    toggleMute,
    isMuted,
    volume,
    setVolumeLevel,
  }: {
    toggleMute: () => void;
    setVolumeLevel: (newVolume: number) => void;
    isMuted: boolean;
    volume: number;
  }) => {
    const [open, setOpen] = useState(false);
    const isVolumeOff = isMuted || volume === 0;

    const trackBackground = `
      linear-gradient(
        to right,
        #fff 0%, 
        #fff ${volume * 100}%, 
        #949495 ${volume * 100}%, 
        #949495 100%
      )
    `;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setVolumeLevel(parseFloat(e.target.value));
    };

    const closeFn = () => {
      setOpen(false);
    };

    return (
      <div className="flex items-center gap-4" onMouseLeave={closeFn}>
        <div onClick={toggleMute} onMouseOver={() => setOpen(true)}>
          {isVolumeOff ? <IconVolumeOff className="player-icon" /> : <IconVolume className="player-icon" />}
        </div>
        <AnimatePresence>
          {open && (
            <motion.input
              animate={{ opacity: 1 }}
              initial={{ opacity: 0 }}
              exit={{ opacity: 0 }}
              type="range"
              step="0.01"
              min={0}
              max={1}
              value={volume}
              onChange={handleChange}
              className="volume-controller h-2 max-lg:h-[5px]"
              style={{
                background: trackBackground,

                borderRadius: "8px",
                appearance: "none",
                width: "100%",
                cursor: "pointer",
                outline: "none",
              }}
            />
          )}
        </AnimatePresence>
      </div>
    );
  },
);
MuteButton.displayName = "MuteButton";

export default MuteButton;
